module.exports = __webpack_public_path__ + "dist/img/bmw-logo-dark.21906f2b.png";